import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { INoteRecord } from "../../lib/types";
import pb from "../../lib/pocketbase";
import { useNavigate, useParams } from "react-router-dom";
import Markdown, { MarkdownStyle } from "../../components/markdown/Markdown";
import Container from "../../components/Container";
import { Skeleton } from "../../components/ui/skeleton";
import ModeSwitch from "../../components/ModeSwitch";
import BackButton from "../../components/form/BackButton";

export default function PublicNote() {
    const navigate = useNavigate();
    const id = useParams().id;
    const [loading, setLoading] = useState(true);
    const [note, setNote] = useState<INoteRecord>();

    async function load() {
        if (!id) {
            navigate("/404");
            return;
        }
        try {
            const record: INoteRecord = await pb.collection("note").getOne(id);
            setNote(record);
            setLoading(false);
        } catch (e) {
            navigate("/404");
        }
    }

    useEffect(() => {
        load();
    }, []);

    if (loading)
        return (
            <div>
                <Container variant={"small"} className="my-8 @container md:my-8 lg:my-16">
                    <div className="flex items-center gap-2">
                        <Skeleton className="h-6 w-12 rounded" />
                        <Skeleton className="h-6 w-14 rounded" />
                    </div>
                    <Skeleton className="mt-4 h-8 w-72 rounded" />
                    <Skeleton className="mt-1 h-4 w-48 rounded" />
                    <Skeleton className="mt-1 h-4 w-40 rounded" />
                    <Skeleton className="mt-16 h-8 w-64 rounded" />
                    <div className="mt-4 flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-6 w-6 rounded" />
                            <Skeleton className="h-6 w-32 rounded" />
                        </div>
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-6 w-6 rounded" />
                            <Skeleton className="h-6 w-32 rounded" />
                        </div>
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-6 w-6 rounded" />
                            <Skeleton className="h-6 w-32 rounded" />
                        </div>
                    </div>
                </Container>
            </div>
        );

    return (
        <>
            <Helmet>
                <title>ReinVB — Note — {note?.name}</title>
            </Helmet>
            <div className="flex justify-end p-4">
                <ModeSwitch className="rounded bg-white px-2 py-2 dark:bg-slate-900" />
            </div>

            <Container variant={"small"} className="my-8 @container md:my-8 lg:my-16">
                <MarkdownStyle className="max-w-full">
                    <div className="flex items-center gap-4">
                        <BackButton />
                        <h1 className="mb-0">{note?.name}</h1>
                    </div>
                </MarkdownStyle>
                <Markdown className="mt-12 max-w-full">{note?.content || ""}</Markdown>
            </Container>
        </>
    );
}
